<template>
    <!--Modal Nuevo Solicitud-->
    <transition name="fade">
      <div class="modal-overlay">
        <div class="modal-dialog" role="solicitud">
          <div class="modal-content">
            <div class="modal-header">
              <p class="modal-title" id="exampleModalLabel">Dudas o consultas</p>
              <button type="button" class="closeModel" data-dismiss="modal" aria-label="Cerrar" @click="cancelarSolicitud()">
                      <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
                        <circle cx="15" cy="15" r="15" fill="#006C90"/>
                        <path d="M21 8.97714L19.7914 7.5L15 13.3562L10.2086 7.5L9 8.97714L13.7914 14.8333L9 20.6895L10.2086 22.1667L15 16.3105L19.7914 22.1667L21 20.6895L16.2086 14.8333L21 8.97714Z" fill="white"/>
                      </svg>
                    </button>
            </div>
            <div class="modal-body info">
              <div class="col col-12">
                <label class="title-body">Nombre:</label><br />
                <input class="form-control" v-model="nombreProveedor" type="text"/>
                <h6 class="mensajeError" v-if="mensajeInputnombreProveedor">
                  Debes asignar un nombre al proveedor.
                </h6>
              </div>
              <div class="col col-12">
                <label class="title-body">Teléfono:</label><br />
                <input class="form-control" v-model="telefono" type="number" @input="validarTelefono(telefono)"/>
                <h6 class="mensajeError" v-if="mensajeInputtelefono">
                  Debes asignar un Teléfono al proveedor.
                </h6>
                <h6 class="mensajeError" v-if="mensajeInputtelefonoFormato">
                  El número de teléfono debe comenzar con 56 y seguir con 9 dígitos.
                </h6>
              </div>
              <div class="col col-12">
                <label class="title-body">Correo:</label><br />
                <input class="form-control" v-model="correo" type="mail"/>
                <h6 class="mensajeError" v-if="mensajeInputcorreo">
                  Debes asignar un correo al proveedor.
                </h6>
              </div>  
              <div class="col col-12">
                <label class="title-body">Observación:</label><br />
                <textarea class="form-control" v-model="observacion" rows="8"> </textarea>
                <h6 class="mensajeError" v-if="mensajeInputdetalles">
                  Debes asignar observaciones al proveedor.
                </h6>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-cancelar" @click="cancelarSolicitud()" v-if="false">
                Cancelar
              </button>
              <button type="button" class="btn btn-melon" @click="crearSolicitud(nombreProveedor, observacion, telefono, correo)">
                Enviar
              </button>
            </div>
          </div>
        </div>
      </div>
    </transition>
  
    <Loading v-if="loading"></Loading>
  </template>
    
  <script>
  import { Actions } from "@/store/enums/StoreEnums";
  import { ref } from "vue";
  import { useStore } from "vuex";
  import Loading from "@/components/Loading.vue";
  
  export default {
    name: "Ayuda",
    emits: ["cancelar", "guardarAyuda"],
    components: {
      Loading,
    },
    data() {
      return {
        nombreProveedor: "",
        observacion: "",
        telefono: "",
        correo: "",
      };
    },
    setup(props, { emit }) {
   
      const validarTelefono = (telefono) => {
        const regex = /^56\d{9}$/;

        console.log(telefono,regex.test(telefono))
        mensajeInputtelefonoFormato.value = !regex.test(telefono);
      };

      const store = useStore();
      var loading = ref(false);
      const mensajeInputnombreProveedor = ref(false);
      const mensajeInputdetalles = ref(false);
      const mensajeInputtelefono = ref(false);
      const mensajeInputtelefonoFormato = ref(false);
      const mensajeInputcorreo = ref(false);
  
      const cancelarSolicitud = () => {
        emit("cancelar", null);
      };
  
      const crearSolicitud = async (nombreProveedor, observacion, telefono, correo) => {
        try {
          var error = false;                    
          mensajeInputnombreProveedor.value = false;
          mensajeInputdetalles.value = false;
          mensajeInputtelefono.value = false;
          mensajeInputcorreo.value = false;
  
          if(nombreProveedor == "") {
            mensajeInputnombreProveedor.value = true
            error = true;
          }
          if(observacion == "") {
            mensajeInputdetalles.value = true
            error = true;
          }
          if(telefono == "") {
            mensajeInputtelefono.value = true
            error = true;
          }
          if(correo == "") {
            mensajeInputcorreo.value = true
            error = true;
          }
          
          if(!error) {
            loading.value = true;
            var formData = new FormData();
  
            formData.append("nombreProveedor", nombreProveedor);
            formData.append("observacion", observacion);
            formData.append("telefono", telefono);
            formData.append("correo", correo);
  
            const data = await store.dispatch(Actions.CREATE_AYUDA, formData);
            loading.value = false;
            emit("guardarAyuda", { data });
          }
        } catch (error) {
          console.log(error);
          loading.value = false;
          emit("guardarAyuda", null);
        }
      };
  
      return {
        cancelarSolicitud,
        crearSolicitud,
        loading,
        mensajeInputnombreProveedor,
        mensajeInputdetalles,
        mensajeInputtelefono,
        mensajeInputtelefonoFormato,
        mensajeInputcorreo,
        validarTelefono
      };
    }
  };
  </script>
    
  <style scoped>
  .mensajeError {
  color: #F1416C;
    font-size: 1rem;
    font-weight: 400;
  }
  
  .correosList {
    display: flex;
    justify-content: flex-start;
    align-items: baseline;
    flex-wrap: wrap;
  }
  
  .correosSeleccionados {
    color: var(--white, #fff);
    text-align: center;
    font-size: 0.75rem;
    font-style: normal;
    font-weight: 475;
    line-height: normal;
    border-radius: 10px;
    background: rgba(0, 108, 144, 0.4);
    padding: 0px 5px;
    cursor: pointer;
    margin: 5px;
  }
  
  .options {
    color: #99abb4;
    font-size: 0.8rem;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
  
  .mensaje {
    color: #99abb4;
    font-size: 0.7rem;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
  
  .modal-overlay {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 10;
    background: rgba(0, 0, 0, 0.4);
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .modal-dialog {
    position: fixed !important;
    top: 50px;
    width: 30rem;
    max-width: 30rem !important;
  }
  
  .modal-header {
    height: 60px;
  }
  
  .modal-title {
    color: #006c90;
    font-size: 1.18rem;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }
  
  .closeModel {
    border: 0px;
    background-color: #fff;
  }
  
  .title-body {
    color: #99abb4;
    font-size: 0.875rem;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }

  .btn-melon {
    display: flex;
    width: 140px;
    height: 27px;
    padding: 5px 10px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    flex-shrink: 0;
    border-radius: 10px;
    border: 1px solid #006c90;
    background: #006c90;
    color: #fff;
    text-align: center;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    width: 45%;
  }
  
  .btn-cancelar {
    display: flex;
    width: 140px;
    height: 27px;
    padding: 5px 10px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    flex-shrink: 0;
    border-radius: 10px;
    border: 1px solid #99c4d3;
    background: #99c4d3;
    color: #fff;
    text-align: center;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    width: 45%;
  }
  
  .modal-footer {
    padding: 0px 0px 1.5rem 0px !important;
    border: 0px !important;
    display: flex;
    justify-content: center;
  }
  
  .modal-overlay {
    position: fixed;
  }
  
  .info label{
    margin-top:1.5rem
  }

  .modal-footer {
    margin-top: 2rem !important;
  }
  </style>
    